import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	message: [],
	page: "",
};

export const errorSlice = createSlice({
	name: "error",
	initialState,
	reducers: {
		set: (state, action) => {
			state.message = action.payload.message;
			state.page = action.payload.page;
		},
		drop: () => initialState,
		addError: () => {},
	},
});

export const errorActions = errorSlice.actions;
export const errorReducer = errorSlice.reducer;
